import { render, staticRenderFns } from "./my-videos.vue?vue&type=template&id=57d594d3&scoped=true&"
import script from "./my-videos.vue?vue&type=script&lang=js&"
export * from "./my-videos.vue?vue&type=script&lang=js&"
import style0 from "./my-videos.vue?vue&type=style&index=0&id=57d594d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d594d3",
  null
  
)

export default component.exports